module.exports = __webpack_public_path__ + "img/reset-password.864518f3.png";